import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import {
  getAllowedExtensions,
  type AllowedExtensionsResponse,
} from "@/services/api/configuration";

const allowedExtensionsKeys = {
  all: ["configuration", "allowedExtensions"] as const,
  list: () => [...allowedExtensionsKeys.all] as const,
};

export function useAllowedExtensions(
  options?: Omit<
    UseQueryOptions<AllowedExtensionsResponse, Error>,
    "queryKey" | "queryFn"
  >
) {
  return useQuery<AllowedExtensionsResponse, Error>({
    queryKey: allowedExtensionsKeys.list(),
    queryFn: getAllowedExtensions,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours (1 day)
    gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days (keep in cache for a week)
    ...options,
  });
}
